import { Tabs } from 'src/components';
import { Color } from 'src/constants';
import { Model } from 'src/models';

const TICKETS_PATH = '/dashboard/tickets';

type Props = {
  selected: 'tasks' | 'tickets';
  /**
   * Whose daily tasks the tasks tab links to.
   */
  userId: string;
};

export default function DashboardTabs({ selected, userId }: Props) {
  return (
    <Tabs
      accentColor={Color.accent}
      tabs={[
        {
          label: 'Daily Tasks',
          to: Model.User.getDailyTasksPath(userId),
          selected: selected === 'tasks',
        },
        {
          label: 'Tickets',
          to: TICKETS_PATH,
          selected: selected === 'tickets',
        },
      ]}
    />
  );
}
